import { Box, BoxProps } from "@mui/material";

interface LogoSlimProps {
  sx?: BoxProps["sx"];
  isCollapsed?: boolean;
}

export const LogoSlim = ({ sx, isCollapsed = false }: LogoSlimProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: 50, // ロゴエリア全体の高さ
      transition: "all 0.3s ease",
      overflow: "hidden", // 拡大してもはみ出さないようにする
      ...sx,
    }}
  >
    <img
      src="/assets/icons/empty/Pink and Blue Cupcake Icon Food Logo.svg"
      alt="Logo"
      style={{
        // ▼ サイズ設定（重複しないように注意！）
        width: isCollapsed ? 40 : "auto",
        height: isCollapsed ? 40 : "100%",
        maxWidth: "100%",

        // ▼ 表示位置とモード
        objectFit: "contain",
        // 閉じた時は「center(中央)」、開いた時は「left(左)」基準
        objectPosition: isCollapsed ? "center" : "left center",

        // ▼ 拡大設定
        // 1.4倍に拡大しています。もっと大きくするなら 1.5 や 1.6 に変更してください
        transform: "scale(1.4)",
        transition: "all 0.3s ease",
      }}
    />
  </Box>
);